import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { unwrapListResponse } from '../customer-related/customer-related.util';
import {
  CustomerChargeRow,
  recordBelongsToCustomer,
  toCustomerChargeRow,
} from '../customer-related/customer-module-rows.util';
import { CustomerRelatedListsService } from '../customer-related-lists.service';

@Component({
  selector: 'app-customer-charges-panel',
  templateUrl: './customer-charges-panel.component.html',
  styleUrls: ['./customer-charges-panel.component.sass'],
})
export class CustomerChargesPanelComponent implements OnChanges {
  @Input() customerId: string | null = null;

  rows: CustomerChargeRow[] = [];
  loading = false;
  displayedColumns = ['description', 'value', 'dueDate', 'status'];

  constructor(
    private lists: CustomerRelatedListsService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']) {
      this.load();
    }
  }

  load(): void {
    if (!this.customerId) {
      this.rows = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.lists
      .listCharges(this.customerId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.rows = unwrapListResponse(response)
            .filter((item) => recordBelongsToCustomer(item, this.customerId || ''))
            .map(toCustomerChargeRow);
          this.loading = false;
        },
        error: () => {
          this.rows = [];
          this.loading = false;
          this.toastService.showWarn('Não foi possível carregar as cobranças deste cliente.');
        },
      });
  }

  open(): void {
    if (!this.customerId) return;
    this.router.navigate(['/charges/show', this.customerId], {
      queryParams: { customerType: 'customer' },
    });
  }
}
